import { useFormik } from 'formik';
import moment from 'moment';
import { memo } from 'react';
import * as yup from 'yup';

import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormAutocompleteField from 'components/ui/form/FormAutocompleteField';
import FormDateField from 'components/ui/form/FormDateField';
import FormFileUploadField from 'components/ui/form/FormFileUploadField';
import useFormSubmit from 'hooks/useFormSubmit';

const validationSchema = yup.object({
  file: yup.mixed().required('Excel file yuklash majburiy!'),
  supplier_id: yup.mixed().required('Yuk beruvchi majburiy!'),
  date: yup
    .date()
    .typeError("Sana noto'g'ri kiritilgan!")
    .required('Sana kiritish majburiy!'),
});

const WarehouseImportModal = (props) => {
  const { open, setOpen, setRefetch, itemId, setItemId } = props;

  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      file: '',
      date: moment().format('YYYY-MM-DD'),
      supplier_id: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const url = `/import/importincome/${itemId}`;
      const message = 'Maxsulot qabul qilindi!';
      const type = 'post';

      const newValues = { ...values, warehouse_id: itemId };

      submit(
        { type, contentType: 'formData' },
        newValues,
        url,
        message,
        itemId,
        true,
        handleFinishRequest
      );
    },
  });

  const handleFinishRequest = () => {
    setRefetch(true);
    handleClose();
  };

  const handleClose = () => {
    setItemId('');
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='md'
      PaperProps={{
        className: '!base-border !shadow-none',
      }}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!text-center !bg-gray-100 !mb-2'
      >
        <span>Mahsulot Qabul Qilish Fayl Orqalik</span>
      </DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item lg={6} sm={6} xs={12}>
              <FormDateField
                delay={0.1}
                label='Sana'
                fieldName='date'
                formik={formik}
              />
            </Grid>
            <Grid item lg={6} sm={6} xs={12}>
              <FormAutocompleteField
                delay={0.2}
                label={'Yuk Beruvchi'}
                fieldName='supplier_id'
                formik={formik}
                autocomplete='off'
                path={'/dictionary/suppliers'}
              />
            </Grid>
            <Grid item={true} lg={12} sm={12} xs={12}>
              <FormFileUploadField
                delay={0.0013}
                accept='.xlsx'
                fieldName='file'
                formik={formik}
                label='Faylni Yuklash'
                btnLabel='Faylni Yuklash'
                fileSize={1}
              />
            </Grid>

            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                delay={0.6}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default memo(WarehouseImportModal);
